export class SummaryType {
  static DAY_5MIN = 'day_5min';
  static DAY_30MIN = 'day_30min';

  static type(key: string) {
    switch (key) {
      case SummaryType.DAY_5MIN:
        return '5min';
      case SummaryType.DAY_30MIN:
        return '30min';

      default:
        return '5min';
    }
  }
}

//ダウンロード画面対象期間表示用
export enum TimeRange {
  FROM = 'from',
  TO = 'to',
}
